import type React from 'react';
import { memo } from 'react';

import cn from 'classnames';

import { getSessionBlock } from '@shared/helpers';

import { AvailableIcon, isAvailableNow, useAvailablePeriod } from '@src/entities/available-periods';
import { useTz } from '@src/entities/schedules';

import { SessionContent } from '../session-content';
import { DayStartTime } from '../start-time';
import * as st from './styles.module.scss';

interface Props {
	availableId: number;
	start: Date;
	end: Date;
}

export const AvailableDaySession: React.FC<Props> = memo(({ availableId, start, end }) => {
	const { availablePeriod } = useAvailablePeriod(availableId);
	const { tz } = useTz();

	const blockType = getSessionBlock(
		{ start, end },
		tz,
		availablePeriod?.start_time,
		availablePeriod?.end_time
	);

	const isNow = isAvailableNow(availablePeriod);

	return (
		<div className={cn(st.session, st[blockType], isNow && st.now)}>
			<DayStartTime availableId={availableId} start={start} end={end} />
			<SessionContent blockType={blockType} isNow={isNow}>
				<AvailableIcon id={availableId} />
			</SessionContent>
		</div>
	);
});
